<template>
	<div>
		<div class="dialog-400">
			<el-dialog :title="topText" :visible.sync="textDialog" :modal="false">
				<div :class="classList.join(' ')" class="margin-top-15 text-center">{{ showText }}</div>
				<slot/>
				<div class="text-center margin-top-20">
					<el-button class="u-btn-blue" @click="affirmBtn">确认</el-button>
					<el-button class="u-btn-blueBd" @click="textDialog = false">取消</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DeleteDialog',
	props: {
		classList: {
			type: Array,
			default() {
				return [];
			},
		},
		changeShow: {
			type: Boolean,
			default: false,
			required: true,
		},
		titleText: String,
		promptText: String,
	},
	data() {
		return {
			textDialog: this.changeShow, // 弹框是否显示
			topText: this.titleText, // 头部文字
			showText: this.promptText, // 显示文字
		};
	},
	watch: {
		changeShow(val) {
			this.textDialog = val;
		},
		titleText(val) {
			this.topText = val;
		},
		promptText(val) {
			this.showText = val;
		},
		textDialog(val) {
			this.$emit('update:changeShow', val);
		},
	},
	created() {},
	methods: {
		affirmBtn() {
			this.$emit('affirmClick');
			this.textDialog = false;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
/* 修改el-dialog 弹出表格*/
.dialog-400 .el-dialog {
	background-color: #fff;
	border: 1px solid #2196f3;
	box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.6);
	width: 400px;
}

.dialog-400 .el-dialog__body {
	padding: 5px 20px 20px 20px;
}

.dialog-400 .el-dialog__header {
	background-color: #eee;
	padding: 8px 0;
	text-align: center;
}

.dialog-400 .el-dialog__title {
	font-size: 14px;
	color: #666;
}

.dialog-400 .el-dialog__headerbtn {
	display: none;
}

.dialog-400 .el-dialog__footer {
	padding: 20px 0 30px;
	text-align: center;
}
</style>
